import type { LegacyDataParams } from 'chaika-frontend-types/frontend-cms';

import { AbstractField } from './AbstractField';
import { LegacyDataList } from '@store/models/SystemFields/LegacyData';

export class LegacyDataField extends AbstractField<LegacyDataList, LegacyDataParams[][]> {
    public makeUpdateParams(): LegacyDataParams[][] {
        return this.fieldValue.serialize();
    }

    protected setFieldValue(value: LegacyDataParams[][]): void {
        this.fieldValue = new LegacyDataList(value);
    }
}
